import axios from 'axios';

export const getIP = () => {
    return axios.get('https://api.ipify.org/?format=json');
}